import { ModifierDetail } from './modifier-detail';
import { TimeSlots } from './time-slots';

export class ShoppingCartProduct {
	shoppingCartProductId: number;
	productImage : string;
	productGuid: string;
	itemObjectId: number;
	itemObjectType: string;
	productName: string;
	productType: string;
	productId: number;
	categoryId: number;
	quantity: number;
	taxOptionId: number;
	taxRate: number;
	taxAmount: number;
	discountAmount: number;
	totalPrice: number;
	salesPrice: number;
	price: number;
	isUndefinedPrice: boolean;
	customPrice: number;
	priceAdjustment: string;
	modifierDetails: string;
	selectedModifiers: ModifierDetail[];
	modifierIds: string;
	quantityComped: number;
	guestId: number;
	guestAccountId: number;
	guestAccountName: string;
	guestName: string;
	membershipTypeId: number;
	membershipLength: number;
	startDate: Date;
	startDateValue: string;
	isRenewalPackage: boolean;
	membershipPackageExpiration: Date;
	allowedRenewals: number;
	isActive: boolean;
	isDeleted: boolean;
	payPlan: boolean;
	billingFrequency: string;
	firstPaymentDate: Date;
	nextPaymentDate: Date;
	finalPaymentDate: string;
	ccToken: string;
	arcadeProduct: string;
	arcadeProductName: string;
	parentPackageId: number;
	membershipDiscountAmount: number;
	isPayPlan: boolean;
	isAllowPayment: boolean;
	initialPayment: number;
	payPlanBasePrice: number;
	isAllowPriceOverride: boolean;
	recurringPeriods: number;
	payPlanTypeId: number;
	isArcadeType: boolean;
	isSessionProduct: boolean;
	timeDetails: string;
	startDateTime: Date;
	endDateTime: Date;
	sessionProductId: number;
	productDetaild: number;
	priceWithoutAdjustment: number;
	// taxOptions: ShoppingCartProductTaxModel[];
	isGiftCardEnabled: boolean;
	isSkiDataProduct: boolean;
	isTaxExempted: boolean;
    timeSlot : TimeSlots
	get fullPrice(): number {
		let ttl = this.price;

		if (this.selectedModifiers && this.selectedModifiers.length) {
			this.selectedModifiers.forEach(sm => {
				ttl += (sm.priceAdjustment || 0);
			});
		}

		return ttl;
	}

	get extendedPrice(): number {
		let ttl = this.quantity * this.price;

		if (this.selectedModifiers && this.selectedModifiers.length) {
			this.selectedModifiers.forEach(sm => {
				ttl += this.quantity * (sm.priceAdjustment || 0);
			});
		}

		return ttl;
	}
}
